import { METADATA_TYPE } from './accounts';
import { MODULE_TYPE, OptionItem, PARAMETERS } from './global';

export interface GET_JOBS_PARAMS_REQUEST {
  page?: number;
  limit?: number;
  sort?: string;
  parent_name?: string;
  sitter_name?: string;
  start_datetime?: string;
  end_datetime?: string;
  address?: string;
  status?: any;
  type?: string;
  keyword?: string;
  createdAt?: string;
  total?: number;
  sitter_id?: string;
  is_ac_job?: boolean;
  module_type?: MODULE_TYPE;
}

export interface JOBS_TYPE {
  Parent: {
    email: string;
    first_name: string;
    last_name: string;
    phone_number: string;
  };
  Sitter: {
    email: string;
    first_name: string;
    last_name: string;
    phone_number: string;
  };
  address: {
    block_number: string;
    country: string;
    id: string;
    name: string;
    postal_code: string;
    street: string;
    unit_number: string;
  };
  number: string;
  createdAt: string;
  end_datetime: Date;
  id: string;
  start_datetime: Date | string;
  status: string;
  total: number;
  total_fee: number;
  srequest_number: string;
  job_surcharges: {
    parent_rate: number;
    sitter_rate: number;
    hours: any;
    id: string;
    job_id: string;
    description: string;
    created_by: any;
    updated_by: any;
    createdAt: string;
    updatedAt: string;
    deletedAt: any;
    status: string;
  }[];
  sitter_earning: number;
  JobExtensions: JOB_EXTENSION_ITEM[];
}

export interface JOB_EXTENSION_ITEM {
  end_datetime: string;
  id: string;
  start_datetime: string;
  status: string;
  total: string;
}

export interface JOBS_BODY_RESULT {
  records: JOBS_TYPE[];
  metadata: METADATA_TYPE;
  params?: GET_JOBS_PARAMS_REQUEST | null;
}

export enum JOBS_STATUS {
  PENDING = 'pending',
  UPCOMING = 'upcoming',
  UPCOMING_PAID = 'upcoming paid', // for AC Job when paid successfully
  UPCOMING_INSUFFICIENT = 'upcoming insufficient', // for AC Job when paid insufficient
  STARTED = 'started',
  PENDING_COMPLETION = 'pending completion',
  EXPIRED = 'expired',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
}

export const JOB_STATUSES: OptionItem[] = [
  {
    id: JOBS_STATUS.UPCOMING,
    name: 'Upcoming',
  },
  {
    id: JOBS_STATUS.STARTED,
    name: 'Started',
  },
  {
    id: JOBS_STATUS.PENDING_COMPLETION,
    name: 'Pending Completion',
  },
  {
    id: JOBS_STATUS.COMPLETED,
    name: 'Completed',
  },
  {
    id: JOBS_STATUS.CANCELED,
    name: 'Canceled',
  },
  {
    id: JOBS_STATUS.UPCOMING_INSUFFICIENT,
    name: 'Upcoming Insufficient',
  },
  {
    id: JOBS_STATUS.UPCOMING_PAID,
    name: 'Upcoming Paid',
  },
  {
    id: JOBS_STATUS.PENDING,
    name: 'Pending',
  },
];

export interface JOB_DETAIL_TYPE {
  id: string;
  number: string;
  sitter: {
    id: string;
    first_name: string;
    last_name: string;
    salary_per_hour: number;
  };
  parent: {
    id: string;
    first_name: string;
    last_name: string;
  };
  start_datetime: {
    date: string;
    time: string;
  };
  end_datetime: {
    date: string;
    time: string;
  };
  address: {
    id: string;
    name: string;
    street: string;
    block_number: string;
    unit_number: string;
    country: string;
    postal_code: string;
  };
  type: string;
  children: CHILDREN[];
  sr_id: string;
  status: string;
  total: string;
  special_notes: {
    [key: string]: string;
  };
  is_trial_job: boolean;
  sitter_rate: number;
  sitter_earning: number;
}

export interface UPDATE_JOB_BODY {
  sitter_id?: string;
  start_day?: string;
  start_time?: string;
  end_day?: string;
  end_time?: string;
  special_notes?: string[];
  total?: number;
  address_id?: string;
  status?: string;
  children?: {
    id: string;
    picture: string | null;
    age_range?: number;
    full_name: string;
    date_of_birth?: string;
  }[];
  is_trial_job?: boolean;
}

export interface UPDATE_JOB_STATUS {
  behalf_of?: string;
  status: string;
}

//AC
export interface BODY_GENERATE_JOBS_AC {
  sr_id: string;
}

export interface JOB {
  total: number;
  id: string;
  number: string;
  start_datetime: string;
  end_datetime: string;
  status: string;
  Parent: PARENT;
  Sitter: SITTER;
}

export interface PARENT {
  parent_id: string;
  profile_picture: any;
  User: USER;
}

export interface USER {
  first_name: string;
  last_name: string;
}

export interface SITTER {
  sitter_id: string;
  profile_picture: string;
  User: USER;
}

export interface JOB_TRANSACTION_TYPE {
  id: string;
  job_id: string;
  from: string;
  duration: string;
  amount: string;
  description: string;
  type: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  job: JOB;
}

export interface JOB_TRANSACTION_PARAMS_REQUEST {
  page?: number;
  limit?: number;
  offset?: number;
  search?: string;
  sort?: string;
  parent_id?: string;
  job_id?: string;
  type?: string;
}

export interface JOB_TRANSACTION_STATE {
  records: JOB_TRANSACTION_TYPE[];
  metadata: METADATA_TYPE;
  params?: JOB_TRANSACTION_PARAMS_REQUEST | null;
}

export interface EXTEND_JOB_AC_BODY {
  end_datetime: string;
}

//JOB AC DETAIL//

export interface CHILDREN {
  id: string;
  picture: string | null;
  age_range: number;
  full_name: string;
  date_of_birth: string;
}

export interface ADDRESS {
  id: string;
  name: string;
  Region: REGION;
  street: string;
  region_id: string;
  postal_code: string;
  unit_number: string;
  block_number: string;
  building_name: string;
}

export interface REGION {
  name: string;
}

interface SPECIAL_NOTES {
  '0': string;
  '1': string;
  '2': string;
}

export interface PARENT {
  profile_picture: any;
  User: USER;
}

export interface USER {
  first_name: string;
  last_name: string;
  date_of_birth: string;
  email: string;
  phone_number: string;
}

export interface SITTER {
  salary_per_hour: number;
  rating: number;
  profile_picture: string;
  star_sitter_badge: string;
  User: USER;
}

export interface JOB_AC_DETAIL_TYPE {
  salary_per_hour: number;
  total: number;
  total_origin: number;
  total_extension: number;
  total_hours: number;
  total_hours_origin: number;
  total_hours_extension: number;
  id: string;
  number: string;
  parent_id: string;
  sitter_id: string;
  sr_id: string;
  children: CHILDREN[];
  start_datetime: string;
  end_datetime: string;
  end_datetime_origin: string;
  address: ADDRESS;
  special_notes: SPECIAL_NOTES;
  type: string;
  status: string;
  is_ac_job: boolean;
  is_trial_job: boolean;
  is_paid: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt: any;
  Parent: PARENT;
  Sitter: SITTER;
  ChatChannel: any;
  sitter_rate: number;
}

export interface CHECK_CAN_CREATE_TRIAL_JOB_PARAMS {
  parent_id: string | undefined;
}

export interface GET_ADJUSTMENT_SURCHARGE_PARAMS extends PARAMETERS {
  job_id: string;
}
export interface ADJUSTMENT_SURCHARGE_ITEM {
  id: string;
  job_id: string;
  parent_rate: number | string;
  sitter_rate: number | string;
  description: string;
  created_by: string;
  updated_by: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}
export interface ADJUSTMENT_SURCHARGE_RESPONSE {
  metadata: METADATA_TYPE;
  records: ADJUSTMENT_SURCHARGE_ITEM[];
}

export interface CREATE_ADJUSTMENT_SURCHARGE_PAYLOAD {
  job_id: string;
  data: { description: string; parent_rate: number; sitter_rate: number }[];
}

export interface UPDATE_ADJUSTMENT_SURCHARGE_PAYLOAD {
  data: { id: string; description: string; sitter_rate: number }[];
}
